/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkConnectorConfigDto } from '../models/work-connector-config-dto';
import { WorkConnectorEntityLink } from '../models/work-connector-entity-link';
import { WorkConnectorPermissionReportDto } from '../models/work-connector-permission-report-dto';
import { WorkConnectorRun } from '../models/work-connector-run';
import { WorkConnectorSchemaDto } from '../models/work-connector-schema-dto';
import { WorkConnectorTestResultDto } from '../models/work-connector-test-result-dto';
import { WorkConnectorWebhookEvent } from '../models/work-connector-webhook-event';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkResolveConnectorLinkDto } from '../models/work-resolve-connector-link-dto';
import { WorkStartConnectorRunDto } from '../models/work-start-connector-run-dto';
import { WorkUpdateConnectorConfigDto } from '../models/work-update-connector-config-dto';
import { WorkUpdateConnectorCredentialsDto } from '../models/work-update-connector-credentials-dto';

@Injectable({ providedIn: 'root' })
export class WorkConnectorsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `connectorsV2ControllerFindAll()` */
  static readonly ConnectorsV2ControllerFindAllPath = '/v2/connectors';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkConnectorConfigDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkConnectorConfigDto>>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkConnectorConfigDto>> {
    return this.connectorsV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkConnectorConfigDto>>): Array<WorkConnectorConfigDto> => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerFindAllRuns()` */
  static readonly ConnectorsV2ControllerFindAllRunsPath = '/v2/connectors/runs';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerFindAllRuns()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindAllRuns$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by connectorKey query param.
     *           <p>
     *              <b>Format: </b> filter.connectorKey={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.connectorKey=$not:$like:John Doe&filter.connectorKey=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.connectorKey'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by trigger query param.
     *           <p>
     *              <b>Format: </b> filter.trigger={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.trigger=$not:$like:John Doe&filter.trigger=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.trigger'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>created</li>
     * <li>status</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'created:ASC' | 'created:DESC' | 'status:ASC' | 'status:DESC'>;

    /**
     * List of fields to select.
     *       <p>
     *              <b>Example: </b> id,created,connectorKey,trigger,dryRun
     *           </p>
     *       <p>
     *              <b>Default Value: </b> By default all fields returns. If you want to select only some fields, provide them in query param
     *           </p>
     */
      select?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorRun>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'connectorKey' | 'trigger' | 'dryRun' | 'fullScan' | 'remap' | 'resourceKeys' | 'status' | 'startedAt' | 'finishedAt' | 'countCreated' | 'countUpdated' | 'countSkipped' | 'countConflicts' | 'countUnmatched' | 'countErrors' | 'errorMessage' | 'createdBy'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'trigger'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerFindAllRunsPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.connectorKey', params['filter.connectorKey'], {});
      rb.query('filter.status', params['filter.status'], {});
      rb.query('filter.trigger', params['filter.trigger'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('select', params.select, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkConnectorRun>;
        'meta'?: {
        'select'?: Array<'id' | 'created' | 'connectorKey' | 'trigger' | 'dryRun' | 'fullScan' | 'remap' | 'resourceKeys' | 'status' | 'startedAt' | 'finishedAt' | 'countCreated' | 'countUpdated' | 'countSkipped' | 'countConflicts' | 'countUnmatched' | 'countErrors' | 'errorMessage' | 'createdBy'>;
        'filter'?: {
        'connectorKey'?: (string | Array<string>);
        'status'?: (string | Array<string>);
        'trigger'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerFindAllRuns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindAllRuns(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by connectorKey query param.
     *           <p>
     *              <b>Format: </b> filter.connectorKey={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.connectorKey=$not:$like:John Doe&filter.connectorKey=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.connectorKey'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by trigger query param.
     *           <p>
     *              <b>Format: </b> filter.trigger={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.trigger=$not:$like:John Doe&filter.trigger=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.trigger'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>created</li>
     * <li>status</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'created:ASC' | 'created:DESC' | 'status:ASC' | 'status:DESC'>;

    /**
     * List of fields to select.
     *       <p>
     *              <b>Example: </b> id,created,connectorKey,trigger,dryRun
     *           </p>
     *       <p>
     *              <b>Default Value: </b> By default all fields returns. If you want to select only some fields, provide them in query param
     *           </p>
     */
      select?: string;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorRun>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'connectorKey' | 'trigger' | 'dryRun' | 'fullScan' | 'remap' | 'resourceKeys' | 'status' | 'startedAt' | 'finishedAt' | 'countCreated' | 'countUpdated' | 'countSkipped' | 'countConflicts' | 'countUnmatched' | 'countErrors' | 'errorMessage' | 'createdBy'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'trigger'?: (string | Array<string>);
};
};
}> {
    return this.connectorsV2ControllerFindAllRuns$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorRun>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'connectorKey' | 'trigger' | 'dryRun' | 'fullScan' | 'remap' | 'resourceKeys' | 'status' | 'startedAt' | 'finishedAt' | 'countCreated' | 'countUpdated' | 'countSkipped' | 'countConflicts' | 'countUnmatched' | 'countErrors' | 'errorMessage' | 'createdBy'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'trigger'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorRun>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'connectorKey' | 'trigger' | 'dryRun' | 'fullScan' | 'remap' | 'resourceKeys' | 'status' | 'startedAt' | 'finishedAt' | 'countCreated' | 'countUpdated' | 'countSkipped' | 'countConflicts' | 'countUnmatched' | 'countErrors' | 'errorMessage' | 'createdBy'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'trigger'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerFindOneRun()` */
  static readonly ConnectorsV2ControllerFindOneRunPath = '/v2/connectors/runs/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerFindOneRun()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindOneRun$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorRun>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerFindOneRunPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorRun>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerFindOneRun$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindOneRun(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkConnectorRun> {
    return this.connectorsV2ControllerFindOneRun$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorRun>): WorkConnectorRun => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerFindAllLinks()` */
  static readonly ConnectorsV2ControllerFindAllLinksPath = '/v2/connectors/links';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerFindAllLinks()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindAllLinks$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by connectorKey query param.
     *           <p>
     *              <b>Format: </b> filter.connectorKey={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.connectorKey=$not:$like:John Doe&filter.connectorKey=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.connectorKey'?: Array<string>;

    /**
     * Filter by resourceKey query param.
     *           <p>
     *              <b>Format: </b> filter.resourceKey={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.resourceKey=$not:$like:John Doe&filter.resourceKey=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.resourceKey'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by entityName query param.
     *           <p>
     *              <b>Format: </b> filter.entityName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.entityName=$not:$like:John Doe&filter.entityName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.entityName'?: Array<string>;

    /**
     * Filter by entityId query param.
     *           <p>
     *              <b>Format: </b> filter.entityId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.entityId=$not:$like:John Doe&filter.entityId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.entityId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> modified:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>modified</li>
     * <li>externalLabel</li>
     * <li>status</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'modified:ASC' | 'modified:DESC' | 'externalLabel:ASC' | 'externalLabel:DESC' | 'status:ASC' | 'status:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> externalId,externalLabel
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>externalId</li>
     * <li>externalLabel</li></ul>
     */
      searchBy?: Array<string>;

    /**
     * List of fields to select.
     *       <p>
     *              <b>Example: </b> id,created,modified,connectorKey,resourceKey
     *           </p>
     *       <p>
     *              <b>Default Value: </b> By default all fields returns. If you want to select only some fields, provide them in query param
     *           </p>
     */
      select?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorEntityLink>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'modified' | 'connectorKey' | 'resourceKey' | 'externalId' | 'externalLabel' | 'entityName' | 'entityId' | 'status' | 'conflictDiff' | 'lastError' | 'syncedAt' | 'lastSeenAt'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'resourceKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'entityName'?: (string | Array<string>);
'entityId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerFindAllLinksPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.connectorKey', params['filter.connectorKey'], {});
      rb.query('filter.resourceKey', params['filter.resourceKey'], {});
      rb.query('filter.status', params['filter.status'], {});
      rb.query('filter.entityName', params['filter.entityName'], {});
      rb.query('filter.entityId', params['filter.entityId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
      rb.query('select', params.select, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkConnectorEntityLink>;
        'meta'?: {
        'select'?: Array<'id' | 'created' | 'modified' | 'connectorKey' | 'resourceKey' | 'externalId' | 'externalLabel' | 'entityName' | 'entityId' | 'status' | 'conflictDiff' | 'lastError' | 'syncedAt' | 'lastSeenAt'>;
        'filter'?: {
        'connectorKey'?: (string | Array<string>);
        'resourceKey'?: (string | Array<string>);
        'status'?: (string | Array<string>);
        'entityName'?: (string | Array<string>);
        'entityId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerFindAllLinks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindAllLinks(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by connectorKey query param.
     *           <p>
     *              <b>Format: </b> filter.connectorKey={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.connectorKey=$not:$like:John Doe&filter.connectorKey=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.connectorKey'?: Array<string>;

    /**
     * Filter by resourceKey query param.
     *           <p>
     *              <b>Format: </b> filter.resourceKey={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.resourceKey=$not:$like:John Doe&filter.resourceKey=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.resourceKey'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by entityName query param.
     *           <p>
     *              <b>Format: </b> filter.entityName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.entityName=$not:$like:John Doe&filter.entityName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.entityName'?: Array<string>;

    /**
     * Filter by entityId query param.
     *           <p>
     *              <b>Format: </b> filter.entityId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.entityId=$not:$like:John Doe&filter.entityId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.entityId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> modified:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>modified</li>
     * <li>externalLabel</li>
     * <li>status</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'modified:ASC' | 'modified:DESC' | 'externalLabel:ASC' | 'externalLabel:DESC' | 'status:ASC' | 'status:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> externalId,externalLabel
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>externalId</li>
     * <li>externalLabel</li></ul>
     */
      searchBy?: Array<string>;

    /**
     * List of fields to select.
     *       <p>
     *              <b>Example: </b> id,created,modified,connectorKey,resourceKey
     *           </p>
     *       <p>
     *              <b>Default Value: </b> By default all fields returns. If you want to select only some fields, provide them in query param
     *           </p>
     */
      select?: string;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorEntityLink>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'modified' | 'connectorKey' | 'resourceKey' | 'externalId' | 'externalLabel' | 'entityName' | 'entityId' | 'status' | 'conflictDiff' | 'lastError' | 'syncedAt' | 'lastSeenAt'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'resourceKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'entityName'?: (string | Array<string>);
'entityId'?: (string | Array<string>);
};
};
}> {
    return this.connectorsV2ControllerFindAllLinks$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorEntityLink>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'modified' | 'connectorKey' | 'resourceKey' | 'externalId' | 'externalLabel' | 'entityName' | 'entityId' | 'status' | 'conflictDiff' | 'lastError' | 'syncedAt' | 'lastSeenAt'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'resourceKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'entityName'?: (string | Array<string>);
'entityId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkConnectorEntityLink>;
'meta'?: {
'select'?: Array<'id' | 'created' | 'modified' | 'connectorKey' | 'resourceKey' | 'externalId' | 'externalLabel' | 'entityName' | 'entityId' | 'status' | 'conflictDiff' | 'lastError' | 'syncedAt' | 'lastSeenAt'>;
'filter'?: {
'connectorKey'?: (string | Array<string>);
'resourceKey'?: (string | Array<string>);
'status'?: (string | Array<string>);
'entityName'?: (string | Array<string>);
'entityId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerFindOneLink()` */
  static readonly ConnectorsV2ControllerFindOneLinkPath = '/v2/connectors/links/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerFindOneLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindOneLink$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorEntityLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerFindOneLinkPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorEntityLink>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerFindOneLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindOneLink(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkConnectorEntityLink> {
    return this.connectorsV2ControllerFindOneLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorEntityLink>): WorkConnectorEntityLink => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerResolveLink()` */
  static readonly ConnectorsV2ControllerResolveLinkPath = '/v2/connectors/links/{id}/resolve';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerResolveLink()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerResolveLink$Response(
    params: {
      id: number;
      body: WorkResolveConnectorLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorEntityLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerResolveLinkPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorEntityLink>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerResolveLink$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerResolveLink(
    params: {
      id: number;
      body: WorkResolveConnectorLinkDto
    },
    context?: HttpContext
  ): Observable<WorkConnectorEntityLink> {
    return this.connectorsV2ControllerResolveLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorEntityLink>): WorkConnectorEntityLink => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerFindOne()` */
  static readonly ConnectorsV2ControllerFindOnePath = '/v2/connectors/{connectorKey}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindOne$Response(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorConfigDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorConfigDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindOne(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<WorkConnectorConfigDto> {
    return this.connectorsV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorConfigDto>): WorkConnectorConfigDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerUpdate()` */
  static readonly ConnectorsV2ControllerUpdatePath = '/v2/connectors/{connectorKey}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerUpdate$Response(
    params: {
      connectorKey: string;
      body: WorkUpdateConnectorConfigDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorConfigDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorConfigDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerUpdate(
    params: {
      connectorKey: string;
      body: WorkUpdateConnectorConfigDto
    },
    context?: HttpContext
  ): Observable<WorkConnectorConfigDto> {
    return this.connectorsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorConfigDto>): WorkConnectorConfigDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerUpdateCredentials()` */
  static readonly ConnectorsV2ControllerUpdateCredentialsPath = '/v2/connectors/{connectorKey}/credentials';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerUpdateCredentials()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerUpdateCredentials$Response(
    params: {
      connectorKey: string;
      body: WorkUpdateConnectorCredentialsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorConfigDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerUpdateCredentialsPath, 'put');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorConfigDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerUpdateCredentials$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerUpdateCredentials(
    params: {
      connectorKey: string;
      body: WorkUpdateConnectorCredentialsDto
    },
    context?: HttpContext
  ): Observable<WorkConnectorConfigDto> {
    return this.connectorsV2ControllerUpdateCredentials$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorConfigDto>): WorkConnectorConfigDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerTestConnection()` */
  static readonly ConnectorsV2ControllerTestConnectionPath = '/v2/connectors/{connectorKey}/test';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerTestConnection()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerTestConnection$Response(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorTestResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerTestConnectionPath, 'post');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorTestResultDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerTestConnection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerTestConnection(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<WorkConnectorTestResultDto> {
    return this.connectorsV2ControllerTestConnection$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorTestResultDto>): WorkConnectorTestResultDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerCheckPermissions()` */
  static readonly ConnectorsV2ControllerCheckPermissionsPath = '/v2/connectors/{connectorKey}/diagnostics/permissions';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerCheckPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerCheckPermissions$Response(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorPermissionReportDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerCheckPermissionsPath, 'get');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorPermissionReportDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerCheckPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerCheckPermissions(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<WorkConnectorPermissionReportDto> {
    return this.connectorsV2ControllerCheckPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorPermissionReportDto>): WorkConnectorPermissionReportDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerDescribeSchema()` */
  static readonly ConnectorsV2ControllerDescribeSchemaPath = '/v2/connectors/{connectorKey}/diagnostics/schema';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerDescribeSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerDescribeSchema$Response(
    params: {
      connectorKey: string;

    /**
     * Kommagetrennt, z. B. `SupplierInvoices,Suppliers`; leer = Standardauswahl des Connectors
     */
      resources?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorSchemaDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerDescribeSchemaPath, 'get');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
      rb.query('resources', params.resources, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorSchemaDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerDescribeSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerDescribeSchema(
    params: {
      connectorKey: string;

    /**
     * Kommagetrennt, z. B. `SupplierInvoices,Suppliers`; leer = Standardauswahl des Connectors
     */
      resources?: string;
    },
    context?: HttpContext
  ): Observable<WorkConnectorSchemaDto> {
    return this.connectorsV2ControllerDescribeSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorSchemaDto>): WorkConnectorSchemaDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerUploadFile()` */
  static readonly ConnectorsV2ControllerUploadFilePath = '/v2/connectors/{connectorKey}/files/{sourceKey}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerUploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  connectorsV2ControllerUploadFile$Response(
    params: {
      connectorKey: string;
      sourceKey: string;
      body: {
'file'?: Blob;
}
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorConfigDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerUploadFilePath, 'post');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
      rb.path('sourceKey', params.sourceKey, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorConfigDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerUploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  connectorsV2ControllerUploadFile(
    params: {
      connectorKey: string;
      sourceKey: string;
      body: {
'file'?: Blob;
}
    },
    context?: HttpContext
  ): Observable<WorkConnectorConfigDto> {
    return this.connectorsV2ControllerUploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorConfigDto>): WorkConnectorConfigDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerRemoveFile()` */
  static readonly ConnectorsV2ControllerRemoveFilePath = '/v2/connectors/{connectorKey}/files/{sourceKey}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerRemoveFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerRemoveFile$Response(
    params: {
      connectorKey: string;
      sourceKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorConfigDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerRemoveFilePath, 'delete');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
      rb.path('sourceKey', params.sourceKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorConfigDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerRemoveFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerRemoveFile(
    params: {
      connectorKey: string;
      sourceKey: string;
    },
    context?: HttpContext
  ): Observable<WorkConnectorConfigDto> {
    return this.connectorsV2ControllerRemoveFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorConfigDto>): WorkConnectorConfigDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerStartRun()` */
  static readonly ConnectorsV2ControllerStartRunPath = '/v2/connectors/{connectorKey}/runs';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerStartRun()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerStartRun$Response(
    params: {
      connectorKey: string;
      body: WorkStartConnectorRunDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorRun>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerStartRunPath, 'post');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorRun>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerStartRun$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorsV2ControllerStartRun(
    params: {
      connectorKey: string;
      body: WorkStartConnectorRunDto
    },
    context?: HttpContext
  ): Observable<WorkConnectorRun> {
    return this.connectorsV2ControllerStartRun$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorRun>): WorkConnectorRun => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerRegenerateWebhookToken()` */
  static readonly ConnectorsV2ControllerRegenerateWebhookTokenPath = '/v2/connectors/{connectorKey}/webhook-token';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerRegenerateWebhookToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerRegenerateWebhookToken$Response(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectorConfigDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerRegenerateWebhookTokenPath, 'post');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectorConfigDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerRegenerateWebhookToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerRegenerateWebhookToken(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<WorkConnectorConfigDto> {
    return this.connectorsV2ControllerRegenerateWebhookToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectorConfigDto>): WorkConnectorConfigDto => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerFindWebhookEvents()` */
  static readonly ConnectorsV2ControllerFindWebhookEventsPath = '/v2/connectors/{connectorKey}/webhook-events';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerFindWebhookEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindWebhookEvents$Response(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkConnectorWebhookEvent>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerFindWebhookEventsPath, 'get');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkConnectorWebhookEvent>>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerFindWebhookEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerFindWebhookEvents(
    params: {
      connectorKey: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkConnectorWebhookEvent>> {
    return this.connectorsV2ControllerFindWebhookEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkConnectorWebhookEvent>>): Array<WorkConnectorWebhookEvent> => r.body)
    );
  }

  /** Path part for operation `connectorsV2ControllerReprocessWebhookEvent()` */
  static readonly ConnectorsV2ControllerReprocessWebhookEventPath = '/v2/connectors/{connectorKey}/webhook-events/{id}/reprocess';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorsV2ControllerReprocessWebhookEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerReprocessWebhookEvent$Response(
    params: {
      connectorKey: string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkConnectorsV2Service.ConnectorsV2ControllerReprocessWebhookEventPath, 'post');
    if (params) {
      rb.path('connectorKey', params.connectorKey, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorsV2ControllerReprocessWebhookEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorsV2ControllerReprocessWebhookEvent(
    params: {
      connectorKey: string;
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.connectorsV2ControllerReprocessWebhookEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
